import $ from 'jquery';

const CloseNotification = () => {
    $(document).ready(function () {
        $('.alert').each(function () {
            var $notification = $(this);

            // Skip auto-close for elements with 'no-auto-close' class
            if (!$notification.hasClass('no-auto-close')) {
                var timer = setTimeout(function () {
                    $notification.fadeOut(800, function () {
                        $(this).remove();
                    });
                }, 5000);

                // Store timer reference for clearing if manually closed
                $notification.data('autoCloseTimer', timer);
            }
        });

        $('.close-btn').click(function () {
            var $notification = $(this).closest('.alert');

            // Clear the auto-close timer if it exists
            clearTimeout($notification.data('autoCloseTimer'));

            // Fade out and remove
            $notification.fadeOut(400, function () {
                $(this).remove();
                // Remove the has-warning class from hero banner content
                $('.hero-banner-content').removeClass('has-warning');
                $('.hero-banner-image').addClass('img-has-not-warning');
            });
        });
    });
};

export default CloseNotification;